import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import type { Document } from '@contentful/rich-text-types'

import {
  TextBlockText,
  MediaBlockText,
  MediaBlockTextFieldsFragment,
  TextBlockTextFieldsFragment,
  FooterText,
} from '@/graphql/types'
import getRenderOptions from './getRenderOptions'
import { RenderOptions } from './renderOptions'
import RichTextType from '@/models/contentful/richText-models'

// Use generated fragment types directly - these are what we actually receive from GraphQL queries
// Also accepts RichTextType from models for backward compatibility
export function richTextRenderer(
  richText:
    | TextBlockText
    | MediaBlockText
    | TextBlockTextFieldsFragment
    | MediaBlockTextFieldsFragment
    | FooterText
    | RichTextType
    | null
    | undefined,
  options?: RenderOptions,
): React.ReactElement {
  if (!richText) {
    return <></>
  }
  // Cast json to Document since it's actually a Document from Contentful
  const richTextDocument = richText.json as Document
  // getRenderOptions expects RichTextType (model type), so we cast here
  // The generated types are compatible at runtime, just different TypeScript structures
  const renderOptions = getRenderOptions(richText as unknown as RichTextType, options)
  return <>{documentToReactComponents(richTextDocument, renderOptions)}</>
}
